<header class="header">
  <div class="container">
    <!-- Logo Section -->
    <div class="logo-section">
      <a
        routerLink="/"
        class="logo-link"
        [attr.aria-label]="'header.ariaHome' | translate"
        >
        <img
          [src]="siteLogoSrc"
          [alt]="logoAlt"
          />
        </a>
      </div>

      <!-- Brand Text and Navigation Section -->
      <div class="brand-nav-section" [class.brand-nav-section--no-brand]="!branding.showBrandText">
        @if (branding.showBrandText) {
          <div class="brand-text">
            <div class="brand-title-wrap">
              <a
                routerLink="/"
                class="brand-link"
                [attr.aria-label]="'header.ariaBrand' | translate"
                >
                <span class="main-title">{{ branding.programTitle }}</span>
                <span class="sub-title">{{ branding.programSubtitle }}</span>
                <span class="tagline kcba-brand">
                  {{ branding.tagline }}
                </span>
              </a>
            </div>
          </div>
        }

        <nav class="nav-menu" aria-label="Main navigation">
          <ul class="nav-list">
            <li>
              <a routerLink="/courses" routerLinkActive="active">{{ 'header.courses' | translate }}</a>
            </li>
            <li>
              <a routerLink="/about" routerLinkActive="active">{{ 'header.about' | translate }}</a>
            </li>
            <li>
              <a routerLink="/contact" routerLinkActive="active">{{ 'header.contact' | translate }}</a>
            </li>
          </ul>

          @if (!isLoggedIn) {
            <div class="auth-buttons">
              <a
                routerLink="/login"
                routerLinkActive="active"
                class="btn btn-login"
                [attr.aria-label]="'header.ariaLogin' | translate"
                >
                <i class="material-icons" aria-hidden="true">person</i>
                {{ 'header.login' | translate }}
              </a>
              <a
                routerLink="/register"
                routerLinkActive="active"
                class="btn btn-register"
                [attr.aria-label]="'header.ariaRegister' | translate"
                >
                {{ 'header.register' | translate }}
              </a>
            </div>
          }

          @if (isLoggedIn) {
            <div class="user-menu">
              <div class="dropdown">
                <button
                  class="dropdown-toggle"
                  [attr.aria-label]="'header.ariaUserMenu' | translate"
                  [attr.aria-expanded]="isDropdownOpen"
                  id="user-menu-button"
                  (click)="toggleDropdown()"
                  (keydown.escape)="closeDropdown()"
                  >
                  <i class="material-icons" aria-hidden="true">account_circle</i>
                  <span>{{ currentUser?.firstName || ('common.user' | translate) }}</span>
                </button>
                <div
                  class="dropdown-menu"
                  [class.show]="isDropdownOpen"
                  [attr.aria-hidden]="!isDropdownOpen"
                  aria-labelledby="user-menu-button"
                  >
                  <a
                    routerLink="/dashboard"
                    class="dropdown-item"
                    (click)="closeDropdown()"
                    >
                    <i class="material-icons" aria-hidden="true">dashboard</i>
                    {{ 'header.dashboard' | translate }}
                  </a>
                  <a
                    routerLink="/profile"
                    class="dropdown-item"
                    (click)="closeDropdown()"
                    >
                    <i class="material-icons" aria-hidden="true">person</i>
                    {{ 'header.profile' | translate }}
                  </a>
                  <a
                    routerLink="/profile/communications"
                    class="dropdown-item"
                    (click)="closeDropdown()"
                    >
                    <i class="material-icons" aria-hidden="true">mail</i>
                    {{ 'header.communications' | translate }}
                  </a>
                  <hr class="dropdown-divider" role="separator" />
                  <button
                    (click)="logout()"
                    class="dropdown-item logout-btn"
                    type="button"
                    >
                    <i class="material-icons" aria-hidden="true">logout</i>
                    {{ 'header.logout' | translate }}
                  </button>
                </div>
              </div>
            </div>
          }

          <!-- Language Dropdown (Amazon-style) -->
          <div class="lang-dropdown" [class.open]="isLangDropdownOpen">
            <button
              class="lang-trigger"
              type="button"
              id="lang-dropdown-btn"
              [attr.aria-expanded]="isLangDropdownOpen"
              [attr.aria-haspopup]="true"
              (click)="$event.stopPropagation(); toggleLangDropdown()"
              >
              <span class="lang-trigger-flag">
                <img
                  [src]="currentLanguage === 'en' ? 'https://flagcdn.com/w20/us.png' : 'https://flagcdn.com/w20/es.png'"
                  width="20"
                  [alt]="currentLanguage === 'en' ? 'United States' : 'Spain'"
                  />
                </span>
                <span class="lang-trigger-label">{{ currentLanguage === 'en' ? 'English' : 'Español' }}</span>
                <span class="lang-trigger-arrow" aria-hidden="true">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
                    <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
              </button>

              <div
                class="lang-dropdown-menu"
                [class.show]="isLangDropdownOpen"
                role="menu"
                aria-labelledby="lang-dropdown-btn"
                >
                <button
                  class="lang-option"
                  type="button"
                  role="menuitem"
                  [class.selected]="currentLanguage === 'en'"
                  (click)="selectLanguage('en')"
                  >
                  <span class="lang-option-flag">
                    <img src="https://flagcdn.com/w20/us.png" width="20" alt="United States" />
                  </span>
                  <span class="lang-option-info">
                    <span class="lang-option-name">English</span>
                    <span class="lang-option-native">United States</span>
                  </span>
                  @if (currentLanguage === 'en') {
                    <span class="lang-option-check">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M2 7L5.5 10.5L12 3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </span>
                  }
                </button>

                <button
                  class="lang-option"
                  type="button"
                  role="menuitem"
                  [class.selected]="currentLanguage === 'es'"
                  (click)="selectLanguage('es')"
                  >
                  <span class="lang-option-flag">
                    <img src="https://flagcdn.com/w20/es.png" width="20" alt="Spain" />
                  </span>
                  <span class="lang-option-info">
                    <span class="lang-option-name">Español</span>
                    <span class="lang-option-native">España</span>
                  </span>
                  @if (currentLanguage === 'es') {
                    <span class="lang-option-check">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M2 7L5.5 10.5L12 3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </span>
                  }
                </button>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </header>
